import { useMemo } from 'react';

import {
  NETWORK_SWITCH_CANCELLED,
  NETWORK_SWITCH_FAILED,
  NETWORK_SWITCH_SUCCESS,
} from './analyticEvents';
import { useAnalytics } from './useAnalytics';

export function useChangeWalletNetworkAnalyticEvents(): {
  onSuccess?: () => void;
  onCancelled?: () => void;
  onFailed?: () => void;
} {
  const { sendEvent } = useAnalytics();

  const events = useMemo(
    () => ({
      onSuccess: (): void => {
        sendEvent(NETWORK_SWITCH_SUCCESS);
      },
      onCancelled: (): void => {
        sendEvent(NETWORK_SWITCH_CANCELLED);
      },
      onFailed: (): void => {
        sendEvent(NETWORK_SWITCH_FAILED);
      },
    }),
    [sendEvent],
  );

  return events;
}
